import React from 'react'
import axios from 'axios';
import { Snackbar, SnackbarContent, Button } from '@material-ui/core';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import EditTwoToneIcon from '@material-ui/icons/EditTwoTone';
// import BorderColorRoundedIcon from '@material-ui/icons/BorderColorRounded';
import { Redirect, Link } from "react-router-dom";
import queryString from 'query-string'
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import ModalRegisterDoctor from './ModalRegisterDoctor'
import TermsAndConditionModal from './TermsAndConditionModal'
import ReplayIcon from '@material-ui/icons/Replay'

import 'style/login.css'
import Header from 'components/Header'
import utils from 'Utils'
import whatsappLink from '../whatsappLink'
import Matrix from '../scripts/Matrix'
import Loading from 'components/Loading'

class Login extends React.Component {

  constructor(props) {
    super(props)
    const parsed = queryString.parse(this.props.location.search);
    this.captchaBtn = React.createRef()
    // console.log(parsed)
    const consultRequestId = parsed.consultId || null
    this.counter = 0
    this.state = {
      show: false,
      usernameVal: '',
      smsCodeVal: '',
      captchaCodeVal: '',
      open: false,
      snackMessage: ' ',
      snackType: 'error',
      loading: false,
      formStep: 1,
      redirect: '',
      tempToken: '',
      consultRequestId,
      acceptTerms: false,
      signupForm: {
        fname: '',
        lname: '',
        nationalId: '',
        gender: 'true',
        email: '',
      },
      time: { m: '03', s: '00' },
      seconds: 180,
      maxSeconds: 180,
      captcha: {
        svg: '',
        hash: ''
      }
    }
  }

  componentDidMount() {
    if (Matrix.isLoggedIn()) this.setState({ redirect: this.redirectToChatURL() })

    if (this.state.formStep === 1) this.sendGtmEventForShowLoginFields()

    this.apiGetCaptcha()
  }

  async sendGtmEventForShowLoginFields() {
    console.log('tag manager', 'show login fields')
    utils.sendGtmEvent('Login/SignUp', 'Show')
  }

  async sendGtmEventForClickSendNumberBtn() {
    console.log('tag manager', 'click enter btn')
    utils.sendGtmEvent('Login/SignUp', 'Submit')
  }

  async sendGtmEventForShowSendCodeFields() {
    console.log('tag manager', 'show send code fields')
    utils.sendGtmEvent('Login/SignUp', 'Signed Up | Logged In')
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.formStep === 1 && this.state.formStep === 2) {
      this.sendGtmEventForShowSendCodeFields()

      this.setState({
        seconds: this.state.maxSeconds,
        time: { m: '03', s: '00' }
      })
    }

    if (this.counter === 0 && this.state.formStep === 2)
      this.counter = setInterval(this.startTimer, 1000)

    if (this.state.seconds <= 0) {
      clearInterval(this.counter)
      this.counter = 0
    }
  }

  redirectToChatURL = () => {
    return { pathname: '/chats', state: { consultId: this.state.consultRequestId } }
  }

  handleChange = (event) => {
    let obj = {}
    obj[`${event.target.name}Val`] = utils.faTOen(event.target.value)
    this.setState(obj);
  }

  sendNumber = async () => {
    this.sendGtmEventForClickSendNumberBtn()
    this.setState({ loading: true })
    let result = await axios.post(utils.urls.sendNumberURL, {
      'username': this.state.usernameVal,
      captchaHash: this.state.captcha.hash,
      captchaValue: this.state.captchaCodeVal
    }).catch((e) => {
      console.log(e.response)
      let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
      this.openSnackbar(message)

    });
    this.setState({ loading: false })

    if (!result) return this.apiGetCaptcha()
    // console.log(result)
    if (result.data.success) {
      await this.setState({
        formStep: 2,
        captcha: {
          svg: '',
          hash: ''
        },
        captchaCodeVal: ''
      })

      this.apiGetCaptcha()
    }

  }

  sendCode = async () => {
    this.setState({ loading: true })
    let result = await axios.get(utils.urls.sendNumberURL + (this.state.captcha.hash ? `?captchaHash=${this.state.captcha.hash}&captchaValue=${this.state.captchaCodeVal}` : ''), {
      auth: {
        username: this.state.usernameVal.trim(),
        password: encodeURIComponent(this.state.smsCodeVal.trim()),
        captchaHash: this.state.captcha.hash,
        captchaValue: this.state.captchaCodeVal
      }
    }).catch((e) => {
      console.log(e.response)
      let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
      this.openSnackbar(message)
    });
    this.setState({ loading: false })

    if (!result) return this.apiGetCaptcha()

    if (!result.data.success) {
      this.apiGetCaptcha()
      return this.openSnackbar('خطایی رخ داده است')
    }

    // console.log(result)
    let { token, roles, userObj, matrixUser, blogToken, isPatient } = result.data;
    const mainRole = utils.getMainRole(roles)
    localStorage.setItem("mainRole", mainRole);
    if (matrixUser) {
      localStorage.setItem("n_matrix", JSON.stringify(matrixUser));
      // localStorage.setItem("msgToken", matrixUser['access_token']);
      Matrix.setAccessToken(matrixUser['access_token'])
    }
    // localStorage.setItem("token", token);
    // localStorage.setItem("userId", userObj.userName);

    Matrix.setUserId(userObj.userName)
    localStorage.setItem("blogToken", blogToken);

    if (!(mainRole === 'patient' && !isPatient)) { // if user is patient and ispatient is false then dont set token - is tempToken
      Matrix.setToken(token)

      if (window.localStorage.getItem('questionFromBlog')) {
        const { question, categoryId } = JSON.parse(window.localStorage.getItem('questionFromBlog'))
        this.setState({ redirect: { pathname: '/consult/new', params: { question, categoryId } } })
      } else if (window.localStorage.getItem('doctorProfile')) {

        this.setState({ redirect: { pathname: `/doctors/${window.localStorage.getItem('doctorProfile')}` } })
      } else {
        setTimeout(() => this.setState({ redirect: this.redirectToChatURL() }), 100)
      }

    } else {
      this.setState({ tempToken: token, formStep: 3 })
    }

  }
  openSnackbar = (message, type = 'error') => {
    this.setState({ snackMessage: message, open: true, snackType: type });
  }
  handleClose = () => {
    this.setState({ open: false });
  };

  closeAction = (
    <Button style={{ color: "#fff", minWidth: 'auto', padding: 0 }} onClick={this.handleClose} >
      <CloseRoundedIcon></CloseRoundedIcon>
    </Button>
  );

  wrongNumber = () => {
    this.setState({ formStep: 1 })
  }

  updateSingupForm = (event) => {
    let obj = {}
    obj[event.target.name] = event.target.value
    this.setState({ signupForm: { ...this.state.signupForm, ...obj } });
  }

  handleGender = (event, newGender) => {
    this.setState({ signupForm: { ...this.state.signupForm, gender: newGender } })
  }

  signup = async () => {
    const { nationalId } = this.state.signupForm

    this.setState({ loading: true })

    if (nationalId && !this.isValidIranianNationalCode(nationalId)) {
      this.openSnackbar('لطفا کد ملی را درست وارد کنید')
      this.setState({ loading: false })
      return
    }
    let result = await axios.post(utils.urls.signupURL, {
      ...this.state.signupForm,
      gender: this.state.signupForm.gender === 'true',
      mobile: this.state.usernameVal
    }, {
      headers: {
        'x-access-token': this.state.tempToken
      }
    }).catch((e) => {
      console.log(e.response)
      let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
      this.openSnackbar(message)
    });
    this.setState({ loading: false })

    if (!result) return
    console.log(result)
    let { token, patient, blogToken } = result.data;

    Matrix.setToken(token);
    localStorage.setItem("blogToken", blogToken);
    setTimeout(() => this.setState({ redirect: this.redirectToChatURL() }), 100)

  }

  isValidIranianNationalCode = input => {
    if (
      !/^\d{10}$/.test(input)
      || input === '0000000000'
      || input === '1111111111'
      || input === '2222222222'
      || input === '3333333333'
      || input === '4444444444'
      || input === '5555555555'
      || input === '6666666666'
      || input === '7777777777'
      || input === '8888888888'
      || input === '9999999999'
    ) return false;

    var check = +input[9];
    var sum = Array(9).fill().map((_, i) => +input[i] * (10 - i)).reduce((x, y) => x + y) % 11;
    return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11);
  }

  handleOpenModal = () => this.setState({ show: !this.state.show });

  handleCloseModal = () => this.setState({
    show: false,
    doctor: { fullname: '', mobile: '' }
  })

  acceptTerms = e => this.setState({ acceptTerms: e.target.checked })

  sendNumberAgain = () => {
    this.sendNumber()
    this.counter = 0
    this.setState({
      time: { m: '03', s: '00' },
      seconds: this.state.maxSeconds
    })
  }

  secondsToTime = secs => {
    let divisor_for_minutes = secs % (60 * 60)
    let minutes = Math.floor(divisor_for_minutes / 60)

    let divisor_for_seconds = divisor_for_minutes % 60
    let seconds = Math.ceil(divisor_for_seconds)

    let obj = {
      "m": minutes < 10 ? '0' + minutes : minutes,
      "s": seconds < 10 ? '0' + seconds : seconds
    }

    return obj
  }

  startTimer = () => {
    let seconds = this.state.seconds - 1
    this.secondsToTime(seconds)
    this.setState({
      time: this.secondsToTime(seconds),
      seconds
    });
  }

  timer = () => {
    return (
      <div className="timer-container">
        {this.state.seconds === 0 ?
          <button onClick={this.sendNumberAgain}>ارسال مجدد کد</button> :
          <div>ارسال مجدد کد پیامکی تا &nbsp;<b>{this.state.time.s && this.state.time.s + ' : ' + this.state.time.m}</b></div>
        }
      </div>
    )
  }

  captcha = () => {
    if (!this.state.captcha.svg) return

    return (
      <div className="captcha">
        <div className="hint">لطفا عدد داخل تصویر را در فیلد زیر وارد کنید</div>
        <div className="captchaContent">
          <input name="captchaCode" autoComplete="off" type="number" placeholder="عدد تصویر را وارد کنید" value={this.state.captchaCodeVal} onChange={this.handleChange} />
          <div className="img" dangerouslySetInnerHTML={{ __html: this.state.captcha.svg }}></div>
          <button onClick={this.apiGetCaptcha} ref={this.captchaBtn}><ReplayIcon /></button>
        </div>
      </div>
    )
  }

  UISendCodeForm = () => {
    return (
      <div className="cols smsForm" >
        <div className="hint">لطفا کد ارسال شده به شماره <span>{this.state.usernameVal}</span> را وارد نمایید</div>
        <Button onClick={this.wrongNumber} variant="outlined" style={{ borderRadius: '23px', marginBottom: '10px' }}>
          شماره همراه اشتباه است؟
                <EditTwoToneIcon fontSize="small" />
        </Button>
        <input id="smsCode" name="smsCode" autoComplete="off" placeholder="کد ارسالی" type="number" value={this.state.smsCodeVal} onChange={this.handleChange} />
        {this.timer()}
        {this.captcha()}
        {this.state.smsCodeVal ?
          <div className="button" onClick={this.sendCode}>تایید کد</div> :
          <div className="button button-disable" onClick={() => this.openSnackbar('کد ارسال شده را وارد کنید')}>تایید کد</div>
        }
        <button className="contact-us-btn">
          <a href={whatsappLink}>ارتباط با پشتیبانی</a>
        </button>


        {this.state.loading && <div className="smsFormLoading"><Loading /></div>}
      </div>
    )
  }
  UIInsertMobileForm = () => {
    return (
      <div className="cols mobileForm" >
        <span>شماره همراه تان را وارد نمایید</span>
        <input id="user-name" name="username" placeholder="0912xxxxxxx" type="text" value={this.state.usernameVal} onChange={this.handleChange} />
        {this.captcha()}
        <div className="terms-condition">
          <Link to="/terms-condition">قوانین و مقررات</Link> را قبول دارم
        </div>
        <div class="button" onClick={this.sendNumber}>ورود</div>
        <button className="contact-us-btn">
          <a href={whatsappLink}>ارتباط با پشتیبانی</a>
        </button>
        <div className="sign-up-doctor">
          <button className="doctor-info-btn" onClick={this.handleOpenModal}>ثبت نام به عنوان پزشک</button>
        </div>
        { this.state.loading && <div class="mobileFormLoading"><Loading /></div>}
        <ModalRegisterDoctor
          open={this.state.show}
          onClose={this.handleCloseModal}
          snackbar={this.openSnackbar}
        />
      </div >
    )
  }
  UISignupForm = () => {
    return (
      <>
        <h3 className="hint">فرم ثبت نام زیر را تکمیل نمایید</h3>
        <div className=" signupForm" >
          <div className='form-row'>
            <span className='kv-label'>نام</span>
            <input id="fname" name="fname" placeholder="نام" type="text" value={this.state.signupForm.fname} onChange={this.updateSingupForm} />
          </div>

          <div className='form-row'>
            <span className='kv-label'>نام خانوادگی</span>
            <input id="lname" name="lname" placeholder="نام خانوادگی" type="text" value={this.state.signupForm.lname} onChange={this.updateSingupForm} />
          </div>
          <div className='form-row'>
            <span className='kv-label'>کد ملی</span>
            <input className='nationalId' id="nationalId" name="nationalId" placeholder="کد ملی" type="number" value={this.state.signupForm.nationalId} onChange={this.updateSingupForm} />
          </div>
          <div className='form-row gender-row'>
            <span className='kv-label'>جنسیت</span>
            <ToggleButtonGroup
              value={this.state.signupForm.gender}
              exclusive
              onChange={this.handleGender}
              aria-label="text alignment"
            >
              <ToggleButton value="true" aria-label="male">
                <img src="/images/male.png" alt="male" />
              </ToggleButton>
              <ToggleButton value="false" aria-label="female">
                <img src="/images/female.png" alt="female" />
              </ToggleButton>
            </ToggleButtonGroup>
          </div>

          <div className="terms">
            <div className="terms__checkbox">
              <input type="checkbox" checked={this.state.acceptTerms} onChange={this.acceptTerms} />
              <div><span className="link" onClick={() => this.TermsAndConditionModal.openModal()}>قوانین و مقررات</span> را قبول دارم</div>
            </div>
          </div>
          {this.state.acceptTerms ?
            <div className="button" onClick={this.signup}>ثبت نام</div> :
            <div className="disable">ثبت نام</div>
          }



          {this.state.loading && <div className="smsFormLoading"><Loading /></div>}
        </div>
      </>
    )
  }

  apiGetCaptcha = async () => {
    if (this.captchaBtn.current) this.captchaBtn.current.disabled = true

    const res = await axios.get(utils.urls.captcha + `?serviceId=${this.state.formStep === 1 ? 'signup' : 'login'}`)
      .catch((e) => {
        console.log(e.response)
        let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
        this.openSnackbar(message)
      })

    if (this.captchaBtn.current) this.captchaBtn.current.disabled = false

    if (!res) return
    if (!res.data.success) {
      this.openSnackbar('خطایی رخ داده است')
      return
    }

    this.setState({
      captcha: {
        svg: res.data.captcha,
        hash: res.data.hash
      }
    })
  }

  render() {
    if (this.state.redirect) {
      // console.log(this.state.redirect, '===----====---===---===---')
      return <Redirect to={this.state.redirect} />
    }
    return (
      <div className="pageRoot">
        <TermsAndConditionModal ref={el => this.TermsAndConditionModal = el} />
        <Header title="ورود" showBackButton={false}></Header>
        <div className="loginContainer">
          {/* <h1>ورود به سامانه</h1> */}
          <div className=" cols" style={{ width: "90%", marginTop: '40px', flexWrap: 'nowrap' }}>
            {this.state.formStep === 1 && this.UIInsertMobileForm()} {/* insert mobile form */}
            {this.state.formStep === 2 && this.UISendCodeForm()} {/*insert the sent code*/}
            {this.state.formStep === 3 && this.UISignupForm()} {/*signup form*/}
          </div>
        </div>
        <Snackbar
          classes={{ root: `ti-snackbar-root ${this.state.snackType}` }}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={this.state.open}
          onClose={this.handleClose}

        >
          <SnackbarContent
            message={this.state.snackMessage}
            classes={{ root: 'ti-snackbarcontent-root-default' }}
            action={this.closeAction}
          >

          </SnackbarContent>
        </Snackbar>
      </div>
    )
  }
}
export default Login
